export const   option = {
    title: {      //标题组件
        text: '出货数量趋势图'
    },
    tooltip: {    //提示框组件
        trigger: 'axis'
    },
    legend: {     //图例组件
        data: ['出货数量'],
        left:200
    },
    grid: {       //直角坐标系内绘图网格
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true
    },
    toolbox: {     //工具栏
        feature: {
        }
    },
    xAxis: {       //直角坐标系 grid 中的 x 轴
        type: 'category',
        boundaryGap: false,
        data: []
    },
    yAxis: {       //直角坐标系 grid 中的 y 轴
        type: 'value'
    },
    series: [      //系列列表
        {
            name: '出货数量',
            type: 'line',
            stack: '总量',
            data: []
        }
    ]
 
}